import { render } from "./ZEB_Manufacturer.vue?vue&type=template&id=6f6d1b5c"
import script from "./ZEB_Manufacturer.vue?vue&type=script&lang=js"
export * from "./ZEB_Manufacturer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__